import { createReducer, on } from '@ngrx/store';
import * as SerpApiActions from './serpApi.actions';

export interface SerpApiState {
  locations: any[];
  domains: any[];
  languages: any[];
  loading: boolean;
  error: any;
}

export const initialState: SerpApiState = {
  locations: [],
  domains: [],
  languages: [],
  loading: false,
  error: null
};

export const serpApiReducer = createReducer(
  initialState,
  on(SerpApiActions.updateSerpApi, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(SerpApiActions.updateSerpApiSuccess, state => ({
    ...state,
    loading: false
  })),
  on(SerpApiActions.updateSerpApiFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Load Locations
  on(SerpApiActions.loadLocations, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(SerpApiActions.loadLocationsSuccess, (state, { locations }) => ({
    ...state,
    loading: false,
    locations
  })),
  on(SerpApiActions.loadLocationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Load Domains
  on(SerpApiActions.loadDomains, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(SerpApiActions.loadDomainsSuccess, (state, { domains }) => ({
    ...state,
    loading: false,
    domains
  })),
  on(SerpApiActions.loadDomainsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Load Languages
  on(SerpApiActions.loadLanguages, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(SerpApiActions.loadLanguagesSuccess, (state, { languages }) => ({
    ...state,
    loading: false,
    languages
  })),
  on(SerpApiActions.loadLanguagesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
)
